var style = {"z-qty-picker":"z-qty-picker","z-brand-theme-zooplus":"z-brand-theme-zooplus","z-brand-theme-bitiba":"z-brand-theme-bitiba","z-qty-picker--size-small":"z-qty-picker--size-small","z-qty-picker__arrow":"z-qty-picker__arrow","z-qty-picker__select":"z-qty-picker__select","z-qty-picker--loading":"z-qty-picker--loading"};

export { style as default };
//# sourceMappingURL=QuantityPicker.module.scss.js.map
